import { TEMPLATE_REQUIREMENTS } from "./setupConfig";

export const useSetupStatus = (mappings, almStatus) => {
  const getStepStatus = (stepKey) => {
    const required = TEMPLATE_REQUIREMENTS[mappings.template] || [];

    if (stepKey === "template") {
      return mappings.template ? "completed" : "active";
    }

    if (stepKey === "project") {
      if (!mappings.template) return "pending";
      return mappings.project && almStatus === "valid"
        ? "completed"
        : "active";
    }

    if (stepKey === "issueTypes") {
      if (!required.includes("issueTypes")) return "hidden";
      if (!mappings.project || almStatus !== "valid") return "pending";
      return mappings.issueTypes.length ? "completed" : "active";
    }

    if (stepKey === "fixVersions") {
      if (!required.includes("fixVersions")) return "hidden";
      if (!mappings.project) return "pending";
      return mappings.fixVersions.length ? "completed" : "active";
    }

    return "pending";
  };

  const isSelectionComplete = () => {
    if (!mappings.template) return false;

    const required = TEMPLATE_REQUIREMENTS[mappings.template];

    if (required.includes("project") && !mappings.project) return false;
    if (required.includes("issueTypes") && !mappings.issueTypes.length)
      return false;
    if (required.includes("fixVersions") && !mappings.fixVersions.length)
      return false;

    return true;
  };

  return {
    getStepStatus,
    isSelectionComplete: isSelectionComplete(),
  };
};